import { useWindowSize } from 'usehooks-ts';

export const useResponsive = () => {
    const { width = 0 } = useWindowSize({ debounceDelay: 200 });

    return {
        isPhone: width < 850,
        isTablet: width >= 850 && width < 1500,
        isDesktop: width >= 1500,
    };
};